import { combineReducers } from "redux";
import { reducer as oidc } from "@axa-fr/react-oidc-redux";
import { itemReducer } from "./itemReducer";
import databaseCompaniesReducer from "../redux/reducers/security/databaseCompaniesReducer";
import ReceiptReducer from "../redux/reducers/receipt/receiptReducer";
import SodReducer from "../redux/reducers/so/SodReducer";
export default combineReducers({
  oidc,
  itemReducer,
  ReceiptReducer,
  SodReducer,
  databaseCompaniesReducer,
});
